export const REQUEST_SHOW_SERIAL_NUMBERS = "SERIAL_NUMBERS:REQUEST_SHOW";
export const CLOSE_SERIAL_NUMBERS = "SERIAL_NUMBERS:CLOSE";

// Opens a window listing `serialNrs` (e.g. one line of a transfer) to read and copy.
export const requestShowSerialNumbers = (title, serialNrs) => ({ type: REQUEST_SHOW_SERIAL_NUMBERS, title, serialNrs });
export const closeSerialNumbers = () => ({ type: CLOSE_SERIAL_NUMBERS });
